"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export interface PackageFormData {
  name: string;
  price: number;
  description: string;
  services: string;
}

interface PackageFormDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  formData: PackageFormData;
  onFormDataChange: (data: PackageFormData) => void;
  onSave: () => void;
  onCancel: () => void;
  isEditMode?: boolean;
}

export function PackageFormDialog({
  open,
  onOpenChange,
  formData,
  onFormDataChange,
  onSave,
  onCancel,
  isEditMode = false,
}: PackageFormDialogProps) {
  const updateField = <K extends keyof PackageFormData>(
    field: K,
    value: PackageFormData[K]
  ) => {
    onFormDataChange({ ...formData, [field]: value });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{isEditMode ? "Edit Package" : "Add New Package"}</DialogTitle>
          <DialogDescription>
            {isEditMode ? "Update package details" : "Create a new one-time service package"}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="pkg-name">Package Name *</Label>
            <Input
              id="pkg-name"
              value={formData.name}
              onChange={(e) => updateField("name", e.target.value)}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="pkg-price">Price (QAR) *</Label>
            <Input
              id="pkg-price"
              type="number"
              value={formData.price}
              onChange={(e) =>
                updateField("price", parseFloat(e.target.value) || 0)
              }
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="pkg-description">Description</Label>
            <Input
              id="pkg-description"
              value={formData.description}
              onChange={(e) => updateField("description", e.target.value)}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="pkg-services">Services (one per line) *</Label>
            <Textarea
              id="pkg-services"
              value={formData.services}
              onChange={(e) => updateField("services", e.target.value)}
              placeholder="Pre pressure wash with Water&#10;Spot free rinse&#10;Inside & boot vacuuming"
              rows={6}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button onClick={onSave}>{isEditMode ? "Save Changes" : "Add Package"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

